import {useQuery} from 'react-query'
import {ChildEditModalForm} from './ChildEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getUserById} from '../core/_requests'
import React from 'react'

const ChildEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: user,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-user-${itemIdForUpdate}`,
    () => {
      return getUserById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <ChildEditModalForm isUserLoading={isLoading} user={{_id: undefined}} />
  }

  if (!isLoading && !error && user) {
    return <ChildEditModalForm isUserLoading={isLoading} user={user} />
  }

  return null
}

export {ChildEditModalFormWrapper}
